import { makeStyles } from '@material-ui/core/styles';

const useCommonStyles = makeStyles((Theme) => ({
  notification: {
    color: Theme.palette.gray[750],
    fontSize: Theme.typography.size[1],
    fontFamily: Theme.typography.base.regular,
    '& notification-banner::part(content)': {
      fontSize: Theme.typography.size[2],
      fontFamily: Theme.typography.base.regular,

      [Theme.breakpoints.up('sm')]: {
        fontSize: Theme.typography.size[0],
      },
      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[1],
      },
      [Theme.breakpoints.up('xl')]: {
        fontSize: Theme.typography.size[3],
      },
    },
    '& notification-banner::part(contentTitle)': {
      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[2],
      },
      [Theme.breakpoints.up('xl')]: {
        fontSize: Theme.typography.size[3],
      },
    },
  },
}));

export default useCommonStyles;
